import { StateManager } from "./statemanager";
import { State } from "./state";
import { MyCharacter } from "../objects/mycharacter";
import { InventoryData } from "../gamedata/inventorydata";
import { QuestData } from "../gamedata/questdata";
import { HotIcons } from "../gamedata/hoticons";
import { SkillData } from "../gamedata/skilldata";
import { BuffData } from "../gamedata/buffdata";
import { PartyData } from "../gamedata/partydata";
import { TradeData } from "../gamedata/tradedata";
import { VendingData } from "../gamedata/vendingdata";
import { IngStatus } from "../gamedata/ingstatus";
import { McStats } from "../gamedata/mcstats";
import { NetManager } from "../helpers/netmanager";

export class PreGameState extends State {
    constructor() {
        super();
    }

    enter() {
        const waitDialog = ui.statusDialog("Downloading Character Data...");

        netGame.once("char_data", function (charData: any) {
            // Initialize character
            global.MC = new MyCharacter(null);

            global.MC.inventory = new InventoryData();
            global.MC.quests = new QuestData();
            global.MC.hotIcons = new HotIcons();
            global.MC.skills = new SkillData();
            global.MC.buffs = new BuffData();
            global.MC.party = new PartyData();
            global.MC.trade = new TradeData();
            global.MC.vending = new VendingData();
            global.MC.ingStatus = new IngStatus(global.MC);

            global.MC.name = charData.name;
            global.MC.uniqueTag = charData.uniqueTag;
            global.MC.gender = charData.gender;
            global.MC.position.x = charData.posStart.x;
            global.MC.position.y = charData.posStart.y;
            global.MC.zoneNo = charData.zoneNo;
            global.MC.reviveZoneNo = charData.reviveZoneNo;
            global.MC.face = charData.faceIdx;
            global.MC.hairStyle = charData.hairStyle;
            global.MC.visParts = charData.parts;

            // tagBasicINFO
            global.MC.birthStone = charData.birthStone;
            global.MC.hairColor = charData.hairColor;
            global.MC.job = charData.job;
            global.MC.union = charData.union;
            global.MC.rank = charData.rank;
            global.MC.fame = charData.fame;
            global.MC.isgm = charData.isgm;

            // tagGrowABility
            global.MC.hp = Math.max(0, charData.hp);
            global.MC.mp = charData.mp;
            global.MC.xp = charData.exp;
            global.MC.level = charData.level;
            global.MC.statPoints = charData.bonusPoint;
            global.MC.skillPoints = charData.skillPoint;
            global.MC.bodySize = charData.bodySize;
            global.MC.headSize = charData.headSize;
            global.MC.penaltyXP = charData.penalExp;
            global.MC.fameG = charData.fameG;
            global.MC.fameB = charData.fameB;
            global.MC.pkFlag = charData.pkFlag;
            global.MC.stamina = charData.stamina;
            global.MC.patHp = charData.patHp;
            global.MC.patCoolTime = charData.patCoolTime;

            // tagBasicAbility
            global.MC.stats = new McStats(global.MC);
            global.MC.stats.str = charData.stats.str;
            global.MC.stats.dex = charData.stats.dex;
            global.MC.stats.int = charData.stats.int;
            global.MC.stats.con = charData.stats.con;
            global.MC.stats.cha = charData.stats.cha;
            global.MC.stats.sen = charData.stats.sen;

            // Store calculated stats from server
            global.MC.calculatedStats = charData.calculatedStats;

            // Update character properties with calculated values
            global.MC.moveSpeed = charData.calculatedStats.moveSpeed;

            global.MC.hotIcons.setIcons(charData.hotIcons);

            netGame.once("preload_char", async function (this: any, data: any) {
                if (data.state !== 1) {
                    throw new Error("Got unexpected 1st preload_char state.");
                }

                // Set up NetManager to watch network events BEFORE loading starts
                // This ensures we don't miss any events during the loading process
                // (NetManager.world will be set later when the world actually loads)
                NetManager.watch(netWorld, netGame);

                waitDialog.setMessage("Preparing to load world...");

                // Configure loading state with map and position
                const startZoneNo = charData.zoneNo;
                const startPos = new THREE.Vector3(
                    charData.posStart.x,
                    charData.posStart.y,
                    0
                );

                waitDialog.close();

                // Set map and position BEFORE preparing (so generateLoadingTasks can use them)
                const gameState = StateManager.get("game");
                gameState.setMapAndPosition(startZoneNo, startPos);

                // Set up listener for preload_char state 2 IMMEDIATELY to avoid race condition
                // The server may send state 2 very quickly after state 1
                netGame.once("preload_char", async (data2: any) => {
                    console.log("[PreGameState] preload_char state 2 received in PreGameState");
                    if (data2.state !== 2) {
                        throw new Error("Got unexpected 2nd preload_char state.");
                    }
                    gameState.preloadCharReceived = true;
                    console.log("[PreGameState] Checking if callback exists:", !!gameState.preloadCharCallback);
                    if (gameState.preloadCharCallback) {
                        console.log("[PreGameState] Calling preloadCharCallback");
                        await gameState.preloadCharCallback();
                        console.log("[PreGameState] preloadCharCallback completed");
                    }
                });

                // Prepare and switch to game state
                // NetManager.world will be set in GameState.prepare after world loads
                await StateManager.prepareAndSwitch("game");
            });
        });
    }

    leave() {
        // Nothing to clean up
    }
}

StateManager.register("pregame", PreGameState);
